import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function deleteWhitelabelConfig(id: number): Promise<void> {
  await apiClient.url(`/whitelabel/configs/${id}`).delete().res();
}

export function useDeleteWhitelabelConfig(): UseMutationResult<
  void,
  Error,
  number
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteWhitelabelConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whitelabelKeys.all });
    },
  });
}
